import React from 'react';
import { ProgressSpinner } from 'primereact/progressspinner';
import type { GlyphColor } from '../../../types/glyph';
import SphereRowMolecule from '../SphereRow/SphereRowMolecule';
import './GlobalSearchResultsListMolecule.scss';

export interface SearchResultSphere {
  id: string;
  properties: {
    name: string;
    description?: string;
    glyph?: string;
    glyphColor?: GlyphColor;
    imageId?: string;
  };
  glyph?: string;
  glyphColor?: GlyphColor;
}

export interface GlobalSearchResultsListMoleculeProps {
  results: SearchResultSphere[];
  isSearching: boolean;
  error: string | null;
  selectedIndex: number;
  onResultSelect: (sphere: SearchResultSphere, index: number) => void;
  noResultsText?: string;
  className?: string;
}

const GlobalSearchResultsListMolecule: React.FC<GlobalSearchResultsListMoleculeProps> = ({
  results,
  isSearching,
  error,
  selectedIndex,
  onResultSelect,
  noResultsText = 'No spheres found',
  className = '',
}) => {
  if (isSearching) {
    return (
      <div className={`global-search-results-list ${className}`}>
        <div className="global-search-results-list__loading">
          <ProgressSpinner style={{ width: '30px', height: '30px' }} />
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={`global-search-results-list ${className}`}>
        <div className="global-search-results-list__error">
          <i className="pi pi-exclamation-triangle" />
          <span>{error}</span>
        </div>
      </div>
    );
  }

  if (results.length === 0) {
    return (
      <div className={`global-search-results-list ${className}`}>
        <div className="global-search-results-list__empty">
          <i className="pi pi-search" />
          <span>{noResultsText}</span>
        </div>
      </div>
    );
  }

  return (
    <div className={`global-search-results-list ${className}`}>
      <div className="global-search-results-list__header">
        <span className="global-search-results-list__count">
          {results.length} {results.length === 1 ? 'result' : 'results'} found
        </span>
      </div>
      <div className="global-search-results-list__items">
        {results.map((sphere, index) => (
          <SphereRowMolecule
            key={sphere.id}
            variant="compact"
            sphereId={sphere.id}
            sphereName={sphere.properties.name}
            glyph={sphere.glyph ?? sphere.properties.glyph}
            glyphColor={sphere.glyphColor ?? sphere.properties.glyphColor}
            imageId={sphere.properties.imageId}
            selected={index === selectedIndex}
            onSelect={() => onResultSelect(sphere, index)}
          />
        ))}
      </div>
    </div>
  );
};

export default GlobalSearchResultsListMolecule;
